/* eslint-disable no-constant-condition, no-unused-vars */
import { useState, useEffect } from "react";
import {
  Grid,
  // Switch,
  // FormControlLabel,
  Menu,
  MenuItem,
  IconButton
  // Tooltip
} from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { Icon } from "@iconify/react";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { httprequest } from "../../../data/api";
import Button from "../../../components/Button";
import { toast } from "react-toastify";
import useValidator from "../../../hooks/useValidator";
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import useStyles from "../styles";
import { useNavigate } from "react-router-dom";
import { useUserState } from "../../../context/UserContext";
import WidgetTitle from "../../dashboard/components/WidgetTitle/WidgetTitle";
// import useWindowSize from "../../../hooks/useWindow";

const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
// const TEACHER_SUBJECT_ENDPOINT = "/api/v1/teacher/subjects";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
// const ADMIN_SUBJECT_ENDPOINT = "/api/v1/subjects";
const ASSIGNMENT_CONFIG_ENDPOINT = "/api/v1/assignment-configs";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const TEACHER_SUBJECT = "/api/v1/teacher/class-subject/";
const UPLOAD_ENDPOINT = "/api/v1/upload";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const SESSION_ENDPOINT = "/api/v1/school-plan/session";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";

const CreateAssignment = () => {
  // const [file, setFile] = useState();
  const navigate = useNavigate();
  const styles = useStyles();
  const { userRole } = useUserState();
  const [classData, setClassData] = useState([]);
  // const [subjectData, setSubjectData] = useState([]);
  const [isCreating, setIsCreating] = useState(false);
  // const [subjectData, setSubjectData] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [isDraftCreating, setIsDraftCreating] = useState(false);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [currentAnchor, setCurrentAnchor] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [assignmentValidator, showAssignmentValidator] = useValidator();
  // const [selectedClassSubjects, setSelectedClassSubjects] = useState([]);
  const [disabledInputs, setDisabledInputs] = useState({});

  const [questionImages, setQuestionImages] = useState({});
  // const [activeTerm, setActiveTerm] = useState([]);
  const [allTerm, setAllTerms] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [totalPoints, setTotalPoints] = useState(0);
  const [optionimages, setOptionImages] = useState([]);
  const [descimages, setDescImages] = useState([]);
  const [showSelect, setShowSelect] = useState(false);
  // const width = useWindowSize();
  // const isSmallScreen = width < 700;
  /**
 * Checks if the current user has the role of a teacher.
 * @type {boolean}
 */
  const isTeacher = userRole?.role_type === "employee";

  /**
 * Handles the change event for the CA (Continuous Assessment) checkbox.
 * Toggles the display of additional select options based on the checkbox state.
 *
 * @param {event parameter passed on handleChange} event - The checkbox change event.
 */
  const handleCACheckboxChange = (event) => {
    setShowSelect(event.target.checked);
  };

  /**
 * Handles the change event for uploading a description image.
 * Converts the selected image file to a local URL and sets it in state.
 *
 * @param {event parameter passed on handleChange} event - The file input change event.
 */
  const handleDescImageChange = (event) => {
    if (event?.target?.files?.length > 0) {
      const selectedImage = URL.createObjectURL(event?.target?.files[0]);
      setDescImages([selectedImage]);
    }
  };

  const [questionArr, setQuestionArr] = useState([
    {
      question: "",
      file: {},
      question_index: 1,
      type: "",
      grade_point: "",
      answer: "",
      required: false,
      options: []
    }
  ]);

  const [assignmentForm, setAssignmentForm] = useState({
    subject_id: "",
    term_id: "",
    title: "",
    class_id: "",
    submission_date: "",
    description: "",
    total_grade: 0,
    instruction: "",
    publish_date: "",
    allow_late_submission: false,
    randomize_questions: false,
    randomize_options: false,
    display_score_after_due_date: false,
    is_private: false,
    questions_display_mode: "",
    questions: [
      {
        question_index: 1
      }
    ]
  });

  /**
 * Fetches all available academic sessions from the backend.
 * Updates the sessionData state with the fetched data.
 */
  const getAllSession = () => {
    httprequest
      .get(SESSION_ENDPOINT)
      .then((res) => {
        setSessionData(res?.data?.data);
      })
      .catch(() => {});
  };

  /**
 * Fetches all terms from the backend and filters by session ID.
 * @param {string} Session_id - The ID of the selected session.
 */
  const getAllTerms = (Session_id) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setAllTerms(res?.data?.data.filter((session_term) => session_term?.session_id === Session_id));
        // setActiveTerm(
        //   res?.data?.data.filter(
        //     (active_term) => active_term?.is_current === true
        //   )
        // );
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
 * Handles image upload for a specific question and updates state.
 * @param {Event} event - The file input change event.
 * @param {number} queInd - Index of the question being updated.
 */
  const handleQuestionImageChange = async (event, queInd) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      // Prepare to send the image to the upload endpoint
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response?.data?.data?.[0]?.upload_id,
            file_url: response?.data?.data?.[0]?.file_url
          };

          // Update questionArr with the uploaded image details
          const updatedQuestionArr = questionArr.map((question, index) => index === queInd
            ? { ...question, file: uploadedImageDetails }
            : question
          );
          setQuestionArr(updatedQuestionArr);

          // Update assignmentForm questions with the new questionArr
          setAssignmentForm((prevForm) => ({
            ...prevForm,
            questions: updatedQuestionArr
          }));

          // Add image URL to questionImages state for preview
          const imageUrl = URL.createObjectURL(file);
          setQuestionImages((prevImages) => ({
            ...prevImages,
            [queInd]: imageUrl
          }));
          toast.success(`Image added to question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  /**
 * Handles image upload for a specific option in a question.
 * @param {Event} event - The file input change event.
 * @param {number} optionIndex - Index of the option being updated.
 * @param {number} questionIndex - Index of the question containing the option.
 */
  const handleOptionImageChange = async (event, optionIndex, questionIndex) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      setDisabledInputs((prevDisabled) => ({
        ...prevDisabled,
        [questionIndex]: {
          ...prevDisabled[questionIndex],
          [optionIndex]: true
        }
      }));

      // Prepare to send the image to the upload endpoint
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response.data.data[0].upload_id,
            file_url: response.data.data[0].file_url
          };

          // Update the specific option with only upload_id and file_url
          const updatedQuestionArr = questionArr.map((question, qIndex) => {
            if (qIndex === questionIndex) {
              const updatedOptions = question.options.map((option, oIndex) => oIndex === optionIndex
                ? uploadedImageDetails
                : option
              );

              return { ...question, options: updatedOptions };
            }

            return question;
          });

          setQuestionArr(updatedQuestionArr);

          // Update assignmentForm questions with the new questionArr
          setAssignmentForm((prevForm) => ({
            ...prevForm,
            questions: updatedQuestionArr
          }));

          const imageUrl = URL.createObjectURL(file);
          setOptionImages((prevImages) => ({
            ...prevImages,
            [`${questionIndex}-${optionIndex}`]: imageUrl
          }));

          toast.success(`Image added to option ${optionIndex + 1} in question ${questionIndex + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  /**
 * Deletes an uploaded image for a specific question.
 * @param {number} queInd - Index of the question whose image is to be removed.
 */
  const removeQueImage = async (queInd) => {
    const upload_id = questionArr[queInd]?.file?.upload_id;

    if (!upload_id) {
      toast.error("No upload ID found for this question");

      return;
    }

    try {
      // This makes a DELETE request to remove the image from the database
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);

      if (response?.status === 200) {
        // Image successfully removed, also updates the questionArr to remove the image for the specific question
        setQuestionArr((prevQuestions) => prevQuestions.map((question, index) => index === queInd
          ? {
            ...question,
            file: {}
          }
          : question
        )
        );

        // Remove image preview from the state
        setQuestionImages((prevImages) => {
          const updatedImages = { ...prevImages };
          delete updatedImages[queInd];

          return updatedImages;
        });
      } else {
        toast.error(response?.data);
      }
    } catch (error) {
      toast.error(error?.response?.message);
    }
  };

  /**
 * Deletes an uploaded image for a specific option in a question.
 * @param {number} i - Index of the option.
 * @param {number} queInd - Index of the question containing the option.
 */
  const removeOptionImage = async (i, queInd) => {
    const question = questionArr[queInd];
    const option = question?.options?.[i];
    const upload_id = option?.upload_id;

    if (!question || !option) {
      toast.error("Question or option not found");

      return;
    }

    if (!upload_id) {
      toast.error("No upload ID found for this option");

      return;
    }

    try {
      // DELETE request to remove the image of the option
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);

      if (response?.status === 200) {
        // Image haes been removed, update the questionArr to remove the image for the specific option
        setQuestionArr((prevQuestions) => prevQuestions.map((question, index) => {
          if (index === queInd) {
            const updatedOptions = question.options.map((option, optionIndex) => optionIndex === i ? { ...option, upload_id: "", file_url: "" } : option
            );

            return { ...question, options: updatedOptions };
          }

          return question;
        })
        );

        // Remove image preview from the state
        setOptionImages((prevImages) => {
          const updatedImages = { ...prevImages };
          delete updatedImages[`${queInd}-${i}`];

          return updatedImages;
        });

        toast.success(`Option ${i + 1} of Question ${queInd + 1} image removed successfully`);
      } else {
        toast.error(response?.data);
      }
    } catch (error) {
      toast.error(error?.response?.message);
    }
  };

  /**
 * Handles session dropdown change and fetches terms for selected session.
 * @param {event parameter passed on handleChange} e - Change event from session dropdown.
 */
  const handleEditSessionChange = (e) => {
    const { value } = e.target;
    // setAssignmentForm({ ...assignmentForm, [name]: value });
    getAllTerms(value);
  };

  useEffect(() => {
  }, [optionimages]);

  /**
 * Triggers click on hidden file input for question image.
 * @param {number} queInd - Index of the question.
 */
  const handleIconClick = (queInd) => {
    document.getElementById(`imageInput-${queInd}`).click();
  };
  /**
 * Triggers click on hidden file input for option image.
 * @param {number} i - Index of the option.
 * @param {number} queInd - Index of the question.
 */
  const handleIconOptionClick = (i, queInd) => {
    document.getElementById(`imageInput-${i}${queInd}`).click();
  };

  /**
 * Handles change to assignment input fields (e.g., title, instruction).
 * @param {event parameter passed on handleAssignmentChange} e
 */
  const handleAssignmentChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAssignmentForm({ ...assignmentForm, [name]: type === "checkbox" ? checked : value });
  };

  /**
 * Handles subject selection change for the assignment.
 * @param {React.ChangeEvent<HTMLInputElement>} e
 */
  const handleSubjectAssignmentChange = (e) => {
    const { value } = e.target;

    setAssignmentForm({ ...assignmentForm, subject_id: value });
  };

  /**
   * Builds the assignment config payload to match the new API shape.
   * This creates ONLY the config (no questions yet), similar to Test and Exam.
   */
  const buildAssignmentConfigPayload = (status = "published") => {
    const submission = assignmentForm.submission_date ? new Date(assignmentForm.submission_date).toISOString() : null;

    return {
      class_id: assignmentForm.class_id || null,
      subject_id: assignmentForm.subject_id || null,
      term_id: assignmentForm.term_id || null,
      title: (assignmentForm.title || "").trim() || null,
      description: (assignmentForm.description || "").trim() || "",
      instructions: (assignmentForm.instruction || "").trim() || "",
      submission_date: submission,
      allow_late_submission: assignmentForm.allow_late_submission === "true" || assignmentForm.allow_late_submission === true,
      randomize_questions: assignmentForm.randomize_questions === "true" || assignmentForm.randomize_questions === true,
      randomize_options: assignmentForm.randomize_options === "true" || assignmentForm.randomize_options === true,
      display_score_after_due_date: assignmentForm.display_score_after_due_date === "true" || assignmentForm.display_score_after_due_date === true,
      is_private: assignmentForm.is_private === "true" || assignmentForm.is_private === true,
      questions_display_mode: assignmentForm.questions_display_mode || "all_at_once",
      status
    };
  };

  /**
 * creates assignment CONFIG with status "published" (no questions yet).
 */
  const handleCreateAssignment = () => {
    if (assignmentValidator.allValid()) {
      setIsCreating(true);
      const payload = buildAssignmentConfigPayload("published");
      httprequest
        .post(ASSIGNMENT_CONFIG_ENDPOINT, payload)
        .then((res) => {
          setIsCreating(false);
          toast.success(res?.data?.message);
          const data = res?.data?.data;
          const configId = data?.id ?? res?.data?.id ?? null;
          if (configId) {
            navigate(`/assignments/${configId}`);
          } else if (isTeacher) {
            navigate("/my-assignments");
          } else {
            navigate("/assignments");
          }
        })
        .catch((err) => {
          setIsCreating(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showAssignmentValidator(true);
    }
  };

  /**
 * creates assignment CONFIG with status "draft" (no questions yet).
 */
  const handleCreateDraftAssignment = () => {
    if (assignmentValidator.allValid()) {
      setIsDraftCreating(true);
      const payload = buildAssignmentConfigPayload("draft");
      httprequest
        .post(ASSIGNMENT_CONFIG_ENDPOINT, payload)
        .then((res) => {
          setIsDraftCreating(false);
          toast.success(res?.data?.message);
          const data = res?.data?.data;
          const configId = data?.id ?? res?.data?.id ?? null;
          if (configId) {
            navigate(`/assignments/${configId}`);
          } else if (isTeacher) {
            navigate("/my-assignments");
          } else {
            navigate("/assignments");
          }
        })
        .catch((err) => {
          setIsDraftCreating(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showAssignmentValidator(true);
    }
  };

  /**
 * Handles click on additional menu icon for question.
 * @param {React.MouseEvent} event
 * @param {number} queInd - Index of the question.
 */
  const handleClick = (event, queInd) => {
    setAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };

  /**
 * Closes the additional question menu.
 */
  const handleAdditionalQueClose = () => {
    setAnchorEl(null);
  };

  /**
   *
   * @param {event parameter passed on handleChange} e
   * @param {*} index
   * @param {*} queInd
   */
  const handleMultipleChoiceChange = (e, index, queInd) => {
    const { value } = e.target;

    const options = questionArr[queInd]["options"];
    const newOptionArr = [...options];

    // Update the specific option as a string when typing
    newOptionArr[index] = value;

    const newQueArr = [...questionArr];
    newQueArr[queInd]["options"] = newOptionArr;

    setQuestionArr(newQueArr);
    setAssignmentForm({ ...assignmentForm, questions: newQueArr });
  };

  /**
   * Handles changes in multiple choice text input.
   * @param {event parameter passed on handleChange} e
   * @param {*} index
   * @param {*} queInd
   */
  const handleCorrectChoiceChange = (e, index, queInd) => {
    const { checked, type } = e.target;

    if (type === "radio") {
      const newQuestionArr = [...questionArr];
      newQuestionArr[queInd]["answer"] = [index];
      setQuestionArr(newQuestionArr);
      setAssignmentForm({ ...assignmentForm, questions: newQuestionArr });
    } else if (type === "checkbox") {
      const newQueArr = [...questionArr];
      const answers = newQueArr[queInd]["answer"] || [];

      if (checked) {
        // Add the index to the answers array if the checkbox is checked
        if (!answers.includes(index)) {
          answers.push(index);
        }
      } else {
        // Remove the index from the answers array if the checkbox is unchecked
        const newAnswerArr = answers.filter((_item) => _item !== index);
        newQueArr[queInd]["answer"] = newAnswerArr;
      }

      newQueArr[queInd]["answer"] = answers;
      setQuestionArr(newQueArr);
      setAssignmentForm({ ...assignmentForm, questions: newQueArr });
    }
  };

  /**
 * Handles change to the main question text.
 * @param {event parameter passed on handleChange} e
 * @param {number} index - Index of the question.
 */
  const handleQueChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    setQuestionArr(newQuestionArr);
    setAssignmentForm({ ...assignmentForm, questions: newQuestionArr });
  };

  /**
 * Handles change to the main question text.
 * @param {event parameter passed on handleChange} e
 * @param {number} index - Index of the question.
 */
  const handleQueDescChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    setQuestionArr(newQuestionArr);
    setAssignmentForm({ ...assignmentForm, questions: newQuestionArr });
  };

  /**
 * Handles change to question point value and updates total.
 * @param {event parameter passed on handleChange} e
 * @param {number} index - Index of the question.
 */
  const handleQuePointChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    setQuestionArr(newQuestionArr);

    const newTotalPoints = newQuestionArr.reduce((sum, question) => {
      return sum + (parseFloat(question?.grade_point) || 0);
    }, 0);

    setAssignmentForm({ ...assignmentForm, questions: newQuestionArr, total_grade: newTotalPoints });

    setTotalPoints(newTotalPoints);
  };

  /**
 * Adds a description field to a question.
 */
  const toggleQueDescriptionTrue = () => {
    const newQuestionArr = [...questionArr];
    newQuestionArr[currentAnchor]["description"] = "";
    setQuestionArr(newQuestionArr);
    setAssignmentForm({ ...assignmentForm, questions: newQuestionArr });
  };

  /**
 * Removes the description field from a question.
 * @param {number} index - Index of the question.
 */
  const removeQueDescription = (index) => {
    const newQuestionArr = [...questionArr];
    delete newQuestionArr[index]["description"];
    setQuestionArr(newQuestionArr);
    setAssignmentForm({ ...assignmentForm, questions: newQuestionArr });
  };

  // This Updates the value on the required field on each question.
  // const handleReqQueChange = (e, index) => {
  //   const { name, checked } = e.target;
  //   const newQuestionArr = [...questionArr];
  //   newQuestionArr[index][name] = checked;
  //   setQuestionArr(newQuestionArr);
  //   setAssignmentForm({ ...assignmentForm, questions: newQuestionArr });
  // };

  /**
 * Adds an empty option to the given question.
 * @param {number} queInd - Index of the question.
 */
  const handleAdditionalOptions = (queInd) => {
    const newQueArr = [...questionArr];
    const newRadioArr = [...questionArr[queInd]["options"], [" "]];
    newQueArr[queInd]["options"] = newRadioArr;
    setQuestionArr(newQueArr);
    setAssignmentForm({ ...assignmentForm, questions: newQueArr });
  };

  /**
 * Handles change to question type (e.g., from short answer to multiple choice).
 * Initializes options if they are empty.
 * @param {event parameter passed on handleChange} e
 * @param {number} index - Index of the question.
 */
  const handleQueTypeChange = (e, index) => {
    const { name, value } = e.target;
    const newQuestionArr = [...questionArr];
    newQuestionArr[index][name] = value;
    if (newQuestionArr[index]["options"].length === 0) {
      handleAdditionalOptions(index);
    }
    setQuestionArr(newQuestionArr);
    setAssignmentForm({ ...assignmentForm, questions: newQuestionArr });
  };

  /**
 * Adds a new blank question to the question array and updates the assignment form state.
 * The new question includes default values such as empty strings and a single empty option.
 */
  const handleAdditionalQuestion = () => {
    const newQue = {
      question: "",
      question_index: assignmentForm?.questions?.length + 1,
      type: "",
      answer: "",
      required: false,
      grade_point: "",
      options: [""]
    };

    // Update questionArr
    const updatedQuestionArr = [...questionArr, newQue];
    setQuestionArr(updatedQuestionArr);

    // Update assignmentForm with new the question
    setAssignmentForm((prevForm) => ({
      ...prevForm,
      questions: updatedQuestionArr
    }));
  };

  /**
 * Removes an additional question that was added, based on its index.
 *
 * @param {number} index - The index of the question to be removed from the question array.
 */
  const removeAdditionalQue = (index) => {
    const newQueArr = questionArr.filter((_item, ind) => ind !== index);
    setQuestionArr(newQueArr);
  };

  /**
 * Removes an additional option choice from a question's options list based on the option index and question index.
 *
 * @param {number} index - The index of the option to remove.
 * @param {number} queInd - The index of the question containing the option.
 */
  const removeAdditionalChoice = (index, queInd) => {
    const newQueArr = [...questionArr];
    const newChoiceArr = newQueArr[queInd]["options"]?.filter(
      (_item, ind) => ind !== index
    );
    newQueArr[queInd]["options"] = newChoiceArr;
    setQuestionArr(newQueArr);
    setAssignmentForm({ ...assignmentForm, questions: newQueArr });
  };

  /**
 * Fetches all classes for the current user depending on their role (teacher or admin),
 * and updates the `classData` state with the result.
 */
  const fetchClasses = () => {
    const ENDPOINT = isTeacher ? TEACHER_CLASS_ENDPOINT : ADMIN_CLASS_ENDPOINT;

    httprequest
      .get(ENDPOINT)
      .then((res) => {
        setClassData(res?.data?.data);
      })
      .catch(() => {
      });
  };

  /**
 * Fetches all subjects for a selected class, depending on the user role (teacher or admin),
 * and updates the `allClassSubject` state with the result.
 *
 * @param {string} classValue - The ID or value of the selected class.
 */
  const getAllSubjectForClass = async (classValue) => {
    const ENDPOINT = isTeacher ? TEACHER_SUBJECT : CLASS_SUBJECT;
    httprequest
      .get(`${ENDPOINT}${classValue}`)
      .then((res) => {
        setAllClassSubject(res?.data?.data);
      })
      .catch(() => {
      });
  };

  /**
 * Handles a change in the selected class input,
 * updates the assignment form state and fetches subjects for the selected class.
 *
 * @param {event parameter passed on handleChange} e - The change event from the class select input.
 */
  const handleClassChange = (e) => {
    const { name, value } = e.target;
    setAssignmentForm({ ...assignmentForm, [name]: value });
    getAllSubjectForClass(value);
  };

  /**
 * A list of available question types for an assignment form.
 * Each option includes a value (used internally), a text label (shown to users), and an icon (React component).
 * Some options are commented out and can be enabled as needed.
 *
 * @type {Array<{value: string, text: string, icon: JSX.Element}>}
 */
  const options = [
    // {
    //   value: "paragraph",
    //   text: "Paragraph",
    //   icon: <Icon icon="carbon:text-short-paragraph" width="25" height="25" />
    // },
    {
      value: "multiple_choice",
      text: "Multiple Choice",
      icon: <Icon icon="mdi:radiobox-marked" width="25" height="25" />
    },
    {
      value: "checkbox",
      text: "Checkbox",
      icon: <Icon icon="ci:checkbox-check" width="25" height="25" />
    }
    // {
    //   value: "dropdown",
    //   text: "Dropdown",
    //   icon: <Icon icon="tabler:select" width="25" height="25" />
    // },
    // {
    //   value: "file_upload",
    //   text: "File Upload",
    //   icon: <Icon icon="basil:cloud-upload-outline" width="25" height="25" />
    // },
    // {
    //   value: "date",
    //   text: "Date",
    //   icon: (
    //     <Icon
    //       icon="material-symbols-light:date-range-sharp"
    //       width="25"
    //       height="25"
    //     />
    //   )
    // },
    // {
    //   value: "time",
    //   text: "Time",
    //   icon: <Icon icon="mingcute:time-line" width="25" height="25" />
    // }
  ];

  useEffect(() => {
    fetchClasses();
    getAllTerms();
    getAllSession();
    // getAllAdminSubjects();
  }, []);

  const getAllObtainableScores = (sessionId) => {
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        const data = res?.data?.data || [];
        const found = data.find(
          (obtainable) => obtainable?.session?.id === sessionId
        );
        setObtainableScore(found || []);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Failed to fetch scores");
      });
  };

  useEffect(() => {
    const current = sessionData?.find((session) => session?.current_session === true);
    if (current?.id) {
      getAllObtainableScores(current.id);
    }
  }, [sessionData]);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            {isTeacher ? (
              <div>
                <BreadCrumb
                  link_one="/my-assignments"
                  link_one_name="Assignments"
                  active="Create Assignment"
                  description="Create a new assignment"
                />
              </div>
            ) : (
              <div>
                <BreadCrumb
                  link_one="/assignments"
                  link_one_name="Assignments"
                  active="Create Assignment"
                  description="Create a new assignment"
                />
              </div>
            )}
            <div className="flex gap-10">
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Create Assignment"
                isLoading={isCreating}
                onClick={handleCreateAssignment}
              />
            </div>
          </div>
          <div className="page-content">
            <div className={styles.assignmentcontainerform}>
              <WidgetTitle
                title="Class Information"
                // subtitle="View Metrics for all student attendance in your school"
              />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  {isTeacher ?
                    (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <SelectGroup
                          label="Select Class"
                          required
                          children={
                            <select
                              name="class_id"
                              onChange={handleClassChange}
                            >
                              <option value="">--- Select ---</option>
                              {classData?.map((clss) => {
                                return (
                                  <option key={clss?.class?.id} value={clss?.class?.id}>
                                    {clss?.class?.name}
                                  </option>
                                );
                              })}
                            </select>
                          }
                        />
                        {assignmentValidator.message(
                          "class_id",
                          assignmentForm?.class_id,
                          "required"
                        )}
                      </Grid>
                    ) : (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <SelectGroup
                          label="Select Class"
                          required
                          children={
                            <select
                              name="class_id"
                              onChange={handleClassChange}
                            >
                              <option value="">--- Select ---</option>
                              {classData?.map((clss) => {
                                return (
                                  <option key={clss?.id} value={clss?.id}>
                                    {clss?.class_name}
                                  </option>
                                );
                              })}
                            </select>
                          }
                        />
                        {assignmentValidator.message(
                          "class_id",
                          assignmentForm?.class_id,
                          "required"
                        )}
                      </Grid>
                    )}
                  {isTeacher ?
                    (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <SelectGroup
                          label="Select Subject"
                          required
                          children={
                            <select
                              name="subject_id"
                              onChange={handleSubjectAssignmentChange}
                            >
                              <option value="">--- Select ---</option>

                              {allClassSubject?.map((sub) => {
                                return (
                                  <option key={sub?.subject.id} value={sub?.subject.id}>
                                    {sub?.subject?.name}
                                  </option>
                                );
                              })}
                            </select>
                          }
                        />
                        {assignmentValidator.message(
                          "subject_id",
                          assignmentForm?.subject_id,
                          "required"
                        )}
                      </Grid>) : (
                      <Grid item lg={4} md={4} sm={6} xs={12}>
                        <SelectGroup
                          label="Select Subject"
                          required
                          children={
                            <select
                              name="subject_id"
                              onChange={handleSubjectAssignmentChange}
                            >
                              <option value="">--- Select ---</option>

                              {allClassSubject?.map((sub) => {
                                return (
                                  <option key={sub?.subject_id} value={sub?.subject_id}>
                                    {sub?.subject_name}
                                  </option>
                                );
                              })}
                            </select>
                          }
                        />
                        {assignmentValidator.message(
                          "subject_id",
                          assignmentForm?.subject_id,
                          "required"
                        )}
                      </Grid>
                    )}

                  <Grid item lg={4} md={4} sm={12} xs={12}>
                    <InputGroup
                      label="Submission Date"
                      margin="normal"
                      inputType="date"
                      inputName="submission_date"
                      inputMin={new Date().toISOString().split("T")[0]}
                      onChange={handleAssignmentChange}
                      required
                    />
                    {assignmentValidator.message(
                      "submission_date",
                      assignmentForm?.submission_date,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Select Session"
                      required
                      children={
                        <select
                          onChange={handleEditSessionChange}
                        >
                          <option value="">---Select---</option>
                          {sessionData?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {/* {assignmentValidator.message("Session", assignmentForm?.session, "required")} */}
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Select Term"
                      required
                      children={
                        <select
                          name="term_id"
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>

                          {allTerm?.map((term) => {
                            return (
                              <option key={term?.id} value={term?.id}>
                                {term?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                    {assignmentValidator.message(
                      "Term Id",
                      assignmentForm?.term_id,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={4} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label={
                        <label>
                          <input
                            className="margin-top-5"
                            type="checkbox"
                            name="count_as_test"
                            onChange={handleCACheckboxChange}
                          />
                            Check to count as test
                        </label>
                      }
                      children={
                        showSelect ? (
                          <select name="ca_type" onChange={handleAssignmentChange}>
                            <option value="">--- Select ---</option>
                            {obtainablescore?.ca?.map((ca, index) => (
                              <option key={index} value={ca?.ca_type}>
                                {ca?.ca_type}
                              </option>
                            ))}
                          </select>
                        ) : null
                      }
                    />
                  </Grid>
                  {/* <Grid item lg={4} md={6} sm={12} xs={12}>
                    <Tooltip title="If selected, assignment will be created; otherwise, saved as a draft">
                      <label className={styles.enterque}>Published Date<span className="input-required"> *</span></label>
                    </Tooltip>
                    <InputGroup
                      margin="normal"
                      inputType="date"
                      inputName="publish_date"
                      inputMin={new Date().toISOString().split("T")[0]}
                      onChange={handleAssignmentChange}
                    />
                    {assignmentValidator.message(
                      "Publish Date",
                      assignmentForm?.publish_date,
                      "required"
                    )}
                  </Grid> */}
                </Grid>
              </div>
              <WidgetTitle
                title="Assignment Information"
                // subtitle="View Metrics for all student attendance in your school"
              />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Assignment Title"
                      margin="normal"
                      inputType="text"
                      inputName="title"
                      onChange={handleAssignmentChange}
                      required
                    />
                    {assignmentValidator.message(
                      "title",
                      assignmentForm?.title,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      label="Total Grade"
                      margin="normal"
                      inputType="text"
                      inputName="total_grade"
                      value={totalPoints}
                      disabled
                      onChange={handleAssignmentChange}
                      required
                    />
                    {assignmentValidator.message(
                      "total_grade",
                      assignmentForm?.title,
                      "required"
                    )}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {/* <InputGroup
                      label="Assignment Instruction"
                      margin="normal"
                      inputType="text"
                      inputName="instruction"
                      onChange={handleAssignmentChange}
                    /> */}
                    <div className={styles.inputmargin}>
                      <TextAreaGroup
                        label="Assignment Instruction"
                        inputName="instruction"
                        margin="normal"
                        placeholder=""
                        onChange={handleAssignmentChange}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={styles.inputmargin}>
                      <TextAreaGroup
                        label="Description"
                        inputName="description"
                        margin="normal"
                        placeholder=""
                        onChange={handleAssignmentChange}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
              <WidgetTitle title="Behavior Settings" />
              <div className={styles.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Allow Late Submission"
                      children={
                        <select
                          name="allow_late_submission"
                          value={assignmentForm.allow_late_submission}
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="false">No</option>
                          <option value="true">Yes</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Randomize Questions"
                      children={
                        <select
                          name="randomize_questions"
                          value={assignmentForm.randomize_questions}
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="false">No</option>
                          <option value="true">Yes</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Randomize Options"
                      children={
                        <select
                          name="randomize_options"
                          value={assignmentForm.randomize_options}
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="false">No</option>
                          <option value="true">Yes</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Display Score after Due Date"
                      children={
                        <select
                          name="display_score_after_due_date"
                          value={assignmentForm.display_score_after_due_date}
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="false">No</option>
                          <option value="true">Yes</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup
                      label="Question Display Mode"
                      children={
                        <select
                          name="questions_display_mode"
                          value={assignmentForm.questions_display_mode}
                          onChange={handleAssignmentChange}
                        >
                          <option value="">--- Select ---</option>
                          <option value="all_at_once">All at once</option>
                          <option value="one_per_page">One per page</option>
                        </select>
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <label className={styles.enterque}>
                      <input
                        className="margin-top-5"
                        type="checkbox"
                        name="is_private"
                        checked={!!assignmentForm.is_private}
                        onChange={handleAssignmentChange}
                      />
                      {" "}Visibility (Private)
                    </label>
                  </Grid>
                </Grid>
              </div>
              <div className={styles.btnwrapper}>
                <Button
                  variant="primary"
                  color="btndefault"
                  buttonSize="medium"
                  buttonName="Create Assignment"
                  onClick={handleCreateAssignment}
                  isLoading={isCreating}
                />
              </div>
            </div>
          </div>
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default CreateAssignment;
